module.exports = __webpack_public_path__ + "img/default.646ee72b.svg";